import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'app-card-doughnut-chart',
  standalone: true,
  imports: [ChartModule, Skeleton, CommonModule],
  templateUrl: './card-doughnut-chart.component.html',
  styleUrl: './card-doughnut-chart.component.css',
})
export class CardDoughnutChartComponent implements OnChanges {
  @Input({ required: true }) isLoading: boolean = false;
  @Input({ required: true }) title!: string;
  @Input({ required: true }) labels!: string[];
  @Input({ required: true }) values!: number[];
  @Input({ required: true }) colors!: string[];
  @Input({ required: true }) value1!: string;
  @Input({ required: true }) label1!: string;
  @Input({ required: true }) value2!: string;
  @Input({ required: true }) value3!: string;
  @Input({ required: true }) label3!: string;

  data: any;
  options: any;

  ngOnChanges(changes: SimpleChanges): void {
    this.initChart();
  }

  initChart() {
    this.data = {
      labels: this.labels,
      datasets: [
        {
          data: this.values,
          backgroundColor: this.colors,
        },
      ],
    };

    this.options = {
      maintainAspectRatio: false,
      aspectRatio: 0.3,
      cutout: '50%',
      datalabels: {
        color: '#ffff', // Color del texto
        formatter: (value:any, context:any) => {
          const total = context.chart.data.datasets[0].data.reduce((a:any, b:any) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(2) + '%';
          return percentage;
        }
      }
    };
  }
}
